/* eslint-disable css-modules/no-unused-class */
import ProfileNoLoyaltyWall from '@/components/blocks/profile-no-loyalty-wall/profile-no-loyalty-wall';
import ModuleWrapper, {
  ModuleWrapperProps,
} from '@/components/utilities/module-wrapper/module-wrapper';
import useQueryProfileNoLoyaltyWall from '@/integrations/content/content-modules/profile-no-loyalty-wall/profile-no-loyalty-wall.hooks';
import styles from './profile-no-loyalty-wall.module.scss';

export interface ProfileNoLoyaltyWallContainerProps extends ModuleWrapperProps {
  /** The UUID of the module */
  id: Content.Components['ProfileNoLoyaltyWallHeadlessModuleDto']['id'];
  /** The UUID of the current page */
  pageId: Content.Components['ProfileNoLoyaltyWallHeadlessModuleDto']['pageId'];
}

const ProfileNoLoyaltyWallContainer = ({
  id,
  pageId,
  ...rest
}: ProfileNoLoyaltyWallContainerProps) => {
  const identifiers = { id, pageId };

  const {
    data: dataProfileNoLoyaltyWall,
    isLoading: isLoadingProfileNoLoyaltyWall,
  } = useQueryProfileNoLoyaltyWall({
    parameters: identifiers,
  });

  const isLoading = isLoadingProfileNoLoyaltyWall;

  if (isLoading) {
    return (
      <ModuleWrapper
        {...rest}
        allowOverflow
        className={styles.wrapper}
        padding="none"
      >
        <ProfileNoLoyaltyWall isLoading />
      </ModuleWrapper>
    );
  }

  if (!dataProfileNoLoyaltyWall) {
    return null;
  }

  return (
    <ModuleWrapper
      {...rest}
      allowOverflow
      className={styles.wrapper}
      padding="none"
    >
      <ProfileNoLoyaltyWall
        becomeLoyaltyMemberModal={
          dataProfileNoLoyaltyWall.becomeLoyaltyMemberModal
        }
      />
    </ModuleWrapper>
  );
};

ProfileNoLoyaltyWallContainer.displayName = 'ProfileNoLoyaltyWallContainer';

export default ProfileNoLoyaltyWallContainer;
